// src/app/hooks/usePatientBillingReport.ts
import {useState, useCallback, useEffect} from 'react'
import axios from 'axios'
import {BillingCycleModel} from '../entities/entities'

import {API_ENDPOINTS} from '../constants/apiConstants'
import {useReduxAuth} from '../modules/auth'
import {USER_ROLES} from '../constants/StatusConstants'
import {useMADoctorDropdown} from '../modules/user/context/MADoctorDropdownContext'

export function usePatientBillingReport(patientUuid: string, initialMonthYear: string) {
  const {currentUser} = useReduxAuth()
  const roleId = currentUser?.role_id
  
  // MA Doctor Dropdown
  const maDropdown = useMADoctorDropdown()
  const maSelectedDoctorId = roleId === USER_ROLES.MEDICAL_ASSISTANT ? maDropdown.selectedDoctorId : undefined
  const [latestCycle, setLatestCycle] = useState<BillingCycleModel | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchReport = useCallback(
    async (monthYear?: string) => {
      setLoading(true)
      setError(null)
      try {
        let latestCycle: BillingCycleModel | null = null

        try {
          const response = await axios.get<{
            status: string
            data: {
              latest_cycle: BillingCycleModel | null
            }
          }>(API_ENDPOINTS.GET_PATIENT_LATEST_BILLING_CYCLE(
            patientUuid,
            roleId === USER_ROLES.MEDICAL_ASSISTANT && maSelectedDoctorId
              ? `doctor_id=${maSelectedDoctorId}`
              : null
          ), {
            validateStatus: (status) => status < 500, // Allow 401, 403, etc.
          })

          // Check if we got a successful response
          if (response.status === 200 && response.data?.data?.latest_cycle) {
            latestCycle = response.data.data.latest_cycle
            setLatestCycle(latestCycle)
          }
        } catch (err: any) {
          console.log('Could not fetch billing cycle, falling back to calendar month', err.message)
        }
      } catch (e: any) {
        setError(e.response?.data?.message || e.message)
      } finally {
        setLoading(false)
      }
    },
    [patientUuid, roleId, maSelectedDoctorId]
  )

  // TODO::Fix this
//   const toggleStatus = useCallback(async (row: BillingDataModel) => {
//     const newStatus = row.Patient.status === 1 ? 0 : 1
//     await axios.put(API_ENDPOINTS.UPDATE_PATIENT_STATUS(row.patient_id, newStatus))
//     setData((prev) =>
//       prev.map((r) =>
//         r.patient_id === row.patient_id
//           ? {...r, status: newStatus, Patient: {...r.Patient, status: newStatus}}
//           : r
//       )
//     )
//   }, [])

  useEffect(() => {
    fetchReport()
  }, [fetchReport])

  return {latestCycle, loading, error, fetchReport/*, toggleStatus*/}
}
